<script>


</script>

<script setup lang="ts">
import { computed, inject, Ref } from 'vue';
import Icon from '../Icon.vue';
import TextKindSelector from './TextKindSelector.vue';
import ToolbarBtn from './ToolbarBtn.vue';
import { printEditorContent } from './printAction';
import { exportAsPDF } from './pdfExport';

const blockToFix = inject('blockToFix')
const activeDoc = inject<any>('document')
const showDialog = inject<(name: string) => {}>('showDialog')

const {editor} = defineProps({
  editor: Object
})


const isLinkActive = computed(() => editor?.isActive('link'))
const hasSelection = computed(() => editor?.state.selection.from !== editor?.state.selection.to)


function toggleUnderline() {
  if (!this.editor.isActive('underline')) {
    this.editor.commands.setMark('underline')
  } else {
    this.editor.commands.unsetMark('underline')
  }
}

function openAiPopup() {
  editor.commands.openAiPopup();
}

function addLink() {
  let url = prompt('Enter URL')
  if (url) {
    if (!url.match(/^https?:\/\//)) {
      url = 'https://' + url
    }
    editor.chain().focus().extendMarkRange('link').setLink({ href: url }).run()
  }
}

function unlink() {  
  editor.chain().focus().unsetLink().run()
}

const TOOLTIP_PLACEMENT = 'bottom'

</script>

<template>
  <div class="toolbar bg-base-300" style="border-radius: 10px 10px 0 0;"> 


    <div :style="{display: 'flex',  flex: 1}">

      <ToolbarBtn title="bold" @action="editor.chain().focus().toggleBold().run()"> 
        <v-icon size="15" name="fa-bold" />  
      </ToolbarBtn>
      <ToolbarBtn title="italic" @action="editor.chain().focus().toggleItalic().run()"> 
        <v-icon name="fa-italic" /> 
      </ToolbarBtn>
      
      <ToolbarBtn title="underline" @action="toggleUnderline"> 
        <v-icon name="fa-underline" /> 
      </ToolbarBtn>
      
      <ToolbarBtn title="strikethrough" @action="editor.chain().focus().toggleStrike().run()"> 
        <v-icon name="fa-strikethrough" /> 
      </ToolbarBtn>

      <div class="div bg-base-content/10"></div>

      <ToolbarBtn title="unordered list" @action="editor.chain().focus().toggleBulletList().run()"> 
        <Icon :size="20" name="octicon--list-unordered-24"/>      
        
      </ToolbarBtn>
      
      <ToolbarBtn title="ordered list" @action="editor.chain().focus().toggleOrderedList().run()"> 
        <Icon :size="20" name="octicon--list-ordered-24"/>      
      </ToolbarBtn>

      <ToolbarBtn title="task list" @action="editor.chain().focus().toggleTaskList().run()"> 
        <Icon :size="20" name="octicon--tasklist-24"/>      
      </ToolbarBtn>

      <TextKindSelector title="change text style" tooltipPlacement="top" :editor="editor" />

      <ToolbarBtn v-if='isLinkActive' title="remove link, make it plaine text" @action="unlink"> 
        <Icon :size="20" name="octicon--unlink-16"/>      
      </ToolbarBtn>

      <ToolbarBtn v-if='hasSelection && !isLinkActive' title="make a link" @action="addLink"> 
        <Icon :size="20" name="octicon--link-16"/>      
      </ToolbarBtn>

      <div class="div bg-base-content/10"></div>

      <ToolbarBtn title="document history" @action="showDialog('DocumentHistory')"> 
        <Icon :size="20" name="octicon--history-16"/>
      </ToolbarBtn>

      <div class="div bg-base-content/10"></div>

      <ToolbarBtn title="print document" @action="printEditorContent(activeDoc.title, editor)"> 
        <Icon :size="20" name="gridicons--print"/>
      </ToolbarBtn>

      <!-- <ToolbarBtn title="print document" @action="exportAsPDF(activeDoc.title, editor)"> 
        <Icon :size="20" name="octicon--history-16"/>
      </ToolbarBtn> -->

      
      <div class="a-flex-1"></div>

      <ToolbarBtn title="deselect working text" :disabled="!blockToFix" @action="editor.commands.withdrawToFix()"> 
        <Icon :size="18" name="fluent-mdl2--clear-selection"/>
        
      </ToolbarBtn>
      <ToolbarBtn title="change with AI" @action="editor.commands.aiHelp()"> 
        <Icon :size="16" name="ion--sparkles-sharp"/>
      </ToolbarBtn>
    </div>
  </div>

</template>

<style scoped lang="less">

.toolbar {
  overflow-x: auto;
  position: relative;
  padding: 3px;
  display: flex;
  button  {
    // padding: 5px !important;
    // margin: 0;
  }

  svg.ov-icon  {
    width: 15px;
    height: 15px;
  }

}
.div {
  margin: 1px 3px;
  width: 1px;
}

select {
  border: none;
  outline: none;
}

</style>
